<template>
  <div>
    <h3>Notwendig</h3>

    <label class="form__checkbox">
      <input
        v-model="cookies.required"
        type="checkbox"
        disabled
      >
      <span class="form__checkbox-label">
        Diese Cookies sind für eine gute Funktionalität unserer Website erforderlich und können in unserem System nicht ausgeschaltet werden.
      </span>
    </label>

    <h3>Funktional</h3>

    <label class="form__checkbox">
      <input
        v-model="cookies.functional"
        type="checkbox"
      >
      <span class="form__checkbox-label">
        Diese Cookies werden für einige Videos benötigt, die bei YouTube gehostet werden.
      </span>
    </label>
  </div>
</template>

<script>
import { COOKIE_LIST } from '../settings.js'
import { getCookie, setCookie } from '../functions/cookie.js'
import EventBus from '../functions/event-bus.js'

export default {
  name: 'VSettingsOptions',

  data () {
    return {
      cookies: {
        ...COOKIE_LIST,
        ...getCookie()
      }
    }
  },

  mounted () {
    EventBus.on('save-settings', () => {
      setCookie(this.cookies)
      EventBus.emit('close')
    })
  }
}
</script>
